import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../../services/data.service';


@Component({
	selector: 'app-inq-view',
	imports: [CommonModule, FormsModule],
  providers: [DatePipe],
	templateUrl: './inq-view.component.html',
	styleUrl: './inq-view.component.scss',
})
export class InqViewComponent {
	@Input() inqData: any;

	follow_ups: any = [];
	allCouns: any = [];
	loading = false;
	customCode = '';

  constructor(public dataService: DataService) {
    //
  }

	ngOnChanges() {
		this.loading = true;
    this.dataService.getAllRecords('follow_ups').then((res: any) => {
			this.follow_ups = [];
			if(res && res.length) {
      	this.follow_ups = res.filter((obj: any)=> {
					return obj.inq_id == this.inqData.id;
				});
			}
      this.loading = false;
    });

		this.loading = true;
    this.dataService.getAllRecords('users').then((res: any) => {
			this.allCouns = [];
			if(res && res.length) {
      	this.allCouns = res;
			}
      this.loading = false;
    });
	}

	editClick(inqData: any) {
		//
	}

	getConsName(cid: number) {
		let retVal: any = this.allCouns?.filter((obj: any)=> {
			return obj.id==cid;
		});

		if(retVal) {
			return retVal[0].display_name;
		} else {
			return 'unknown';
		}
	}

	deleteClick(iid: number) {
		//
	}

}
